<audio id="audio_{{ idx }}" class="video-js vjs-default-skin" *ngIf="IsAudio"></audio>
<video id="video_{{idx}}" class="video-js vjs-default-skin"  *ngIf="!IsAudio && !isUsingWrapper"></video>
<div class="row">
    <div class="text-center" *ngIf="!IsAudio && isUsingWrapper"> 
    <button type="button" class="vjs-control vjs-button vjs-icon-file-download btn btn-success btn-sm small-button " (click)="download()">
       Download Video File
    </button>   
  </div> 
  </div>